import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { defer, Observable, throwError as observableThrowError, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FlightSearchRequest } from '../../dtos/request/flight-result-api/flight-search-request';
import { FlightShoppingRequest } from '../../dtos/request/shopping-request/flight-shopping-request';
import { FlightSearchResponse } from '../../dtos/response/flight-result-api/flight-search-response';
import { FlightSearchResponseWrapper } from '../../dtos/response/flight-result-api/flight-search-response-wrapper';
import { FlightShoppingResponse } from '../../dtos/response/shopping-response/flight-shopping-response';
import { FlightShoppingResponseFull } from '../../dtos/response/shopping-response/flight-shopping-response-full';
import { timeoutError } from '../../models/timeout-error';
import { TimeoutLimit } from '../../models/timeout-limit';

export interface FlightShoppingServiceAPI {
  getFlightShoppingResults(request: FlightShoppingRequest): Observable<FlightShoppingResponse>;
  getFlightShoppingFrapi(id: string, request: FlightSearchRequest): Observable<FlightSearchResponseWrapper>;
}

@Injectable()
export class FlightShoppingService implements FlightShoppingServiceAPI {
  private readonly http = inject(HttpClient);

  getFlightShoppingResults(request: FlightShoppingRequest): Observable<FlightShoppingResponse> {
    const options = {
      headers: new HttpHeaders({
        background: 'true',
      }),
    };
    return this.http.post<FlightShoppingResponseFull>('api/flight/shopping', request, options).pipe(
      timeout({
        each: TimeoutLimit.MEDIUM,
        with: () => defer(() => observableThrowError(() => new HttpErrorResponse(timeoutError))),
      }),
      map((response) => {
        return {
          success: true,
          response,
        };
      }),
      catchError((err: HttpErrorResponse) => {
        if (timeoutError.statusText === err.statusText) {
          return of({ success: false, error: 'Timeout' });
        } else if (err.status === 500) {
          return of({ success: false, error: 'System failure' });
        } else {
          return of({ success: false, error: 'Uncaught' });
        }
      })
    );
  }

  getFlightShoppingFrapi(id: string, request: FlightSearchRequest): Observable<FlightSearchResponseWrapper> {
    const options = {
      headers: new HttpHeaders({
        background: 'true',
      }),
    };
    return this.http.post<FlightSearchResponse>('api/flight/shopping/frapi', request, options).pipe(
      timeout({
        each: TimeoutLimit.MEDIUM,
        with: () => defer(() => observableThrowError(() => new HttpErrorResponse(timeoutError))),
      }),
      map((flightSearchResponse) => {
        return { id, response: flightSearchResponse, success: true };
      }),
      catchError((err: HttpErrorResponse) => {
        if (timeoutError.statusText === err.statusText) {
          return of({ id, success: false, error: 'Timeout' });
        } else if (err.status === 500) {
          return of({ id, success: false, error: 'System failure' });
        } else {
          return of({ id, success: false, error: 'Uncaught' });
        }
      })
    );
  }
}
